import actions from "~/shared/actions";
import type { Action } from "~/utils/actions";

export interface AppState {
	canGoBack: boolean;
	returnUrl?: string;
	showUserMenu: boolean;
}

function canGoBack(state: AppState): AppState {
	return { ...state, canGoBack: true };
}

function toggleUserMenu(state: AppState): AppState {
	return { ...state, showUserMenu: !state.showUserMenu };
}

function setReturnUrl(state: AppState, action: Action): AppState {
	return { ...state, returnUrl: action.data };
}

export const defaultState: AppState = {
	canGoBack: false,
	showUserMenu: false,
};

export default function header(state: AppState = defaultState, action: Action) {
	switch (action.type) {
		case actions.CAN_GO_BACK:
			return canGoBack(state);
		case actions.TOGGLE_USER_MENU:
			return toggleUserMenu(state);
		case actions.SET_RETURN_URL:
			return setReturnUrl(state, action);
		default:
			return state;
	}
}
